exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#videoreview[data-v-8b5a4e30]{overflow:scroll}.lists[data-v-8b5a4e30]{height:100%}.list[data-v-8b5a4e30]{width:50%;padding:5px;box-sizing:border-box;overflow:hidden;display:inline-block;vertical-align:top}.img[data-v-8b5a4e30]{width:100%;padding-bottom:56.25%;position:relative;overflow:hidden}.list img[data-v-8b5a4e30]{width:100%;position:absolute;top:50%;left:0;transform:translateY(-50%);height:100%}.title[data-v-8b5a4e30]{height:40px;overflow:hidden;margin:5px 0;line-height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-8b5a4e30","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/menu/VideoReView.vue
// module id = 263
// module chunks = 0